import { ButtonExploreArt } from "@/components/ButtonExploreArts";

const ArtSection = () => {
  return (
    <section className="py-5">
      <div className="flex flex-col md:flex-row flex-wrap justify-center gap-4 mb-8">
        {/* Primeiro bloco */}
        <div className="w-full md:w-1/3 max-w-sm relative">
          <video
            src="./assets/encomenda.mp4"
            autoPlay
            loop
            muted
            className="w-full h-[300px] object-cover rounded-lg"
          ></video>
          <div className="absolute bottom-0 left-0 p-6 text-white bg-gradient-to-t from-black/45 via-transparent to-transparent text-center flex flex-col items-center">
            <h2 className="text-xl font-semibold mb-2 text-marfim">
              Enviamos para todo território Nacional
            </h2>
            <p className="mb-4 text-marfim">
              Não importa onde esteja, nossas peças chegarão até você.
            </p>
            <ButtonExploreArt point="/products" />
          </div>
        </div>

        {/* Segundo bloco */}
        <div className="w-full md:w-1/3 max-w-sm relative">
          <video
            src="./assets/mecanica.mp4"
            autoPlay
            loop
            muted
            className="w-full h-[300px] object-cover rounded-lg"
          ></video>
          <div className="absolute bottom-0 left-0 p-6 text-white bg-gradient-to-t from-black/45 via-transparent to-transparent text-center flex flex-col items-center">
            <h2 className="text-xl font-semibold mb-2 text-marfim">
              Mecânica Especializada
            </h2>
            <p className="mb-4 text-marfim">
              Contamos com profissionais especializados
            </p>
            <ButtonExploreArt point="/products" />
          </div>
        </div>

        {/* Terceiro bloco */}
        <div className="w-full md:w-1/3 max-w-sm relative">
          <video
            src="./assets/viaje.mp4"
            autoPlay
            loop
            muted
            className="w-full h-[300px] object-cover rounded-lg"
          ></video>
          <div className="absolute bottom-0 left-0 p-6 text-white bg-gradient-to-t from-black/45 via-transparent to-transparent text-center flex flex-col items-center">
            <h2 className="text-xl font-semibold mb-2 text-marfim">
              Viagem em segurança
            </h2>
            <p className="mb-4 text-marfim">
              Com nossas peças, você pode viajar com sua família com total confiança
            </p>
            <ButtonExploreArt point="/products" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ArtSection;
